import { designToken, quickProperty } from '../component-tokens';
import { sizeAttributes, nameWithSize } from './utils';
import { borderBase, focusState, primaryElementFocus } from './common';
const getIcon = (color) => ({
    tag: 'svg',
    name: 'icon',
    attributes: {
        color,
        'pointer-events': quickProperty('none'),
    },
});
export const roundButtonTokens = {
    name: 'round-button',
    tag: 'chameleon-round-button',
    reactImports: 'RoundButton',
    attributes: Object.assign(Object.assign(Object.assign({}, sizeAttributes('32px')), borderBase), { 'border-radius': quickProperty('100%'), display: quickProperty('inline-flex'), 'align-items': quickProperty('center'), 'justify-content': quickProperty('center'), cursor: quickProperty('pointer'), outline: quickProperty('0'), flex: quickProperty('none'), '--goto-icon-color': designToken('icon-01'), '--goto-icon-size': quickProperty('16px') }),
    sizes: [
        Object.assign({}, nameWithSize('small', '24px')),
        Object.assign({}, nameWithSize('medium', '32px')),
        Object.assign({}, nameWithSize('large', '40px')),
        Object.assign({}, nameWithSize('xlarge', '48px')),
        Object.assign({}, nameWithSize('xxlarge', '56px')),
    ],
    children: [
        Object.assign(Object.assign({}, getIcon(designToken('icon-01'))), { alias: 'round-button-icon' }),
    ],
    variants: [
        {
            name: 'secondary',
            tag: 'button',
            children: [getIcon(designToken('round-button-icon-color'))],
            attributes: {
                color: designToken('icon-01'),
                'background-color': designToken('interactive-02'),
                'border-color': designToken('ui-02'),
                '--goto-icon-color': designToken('round-button-icon-color'),
            },
            states: [
                {
                    name: 'hover',
                    attributes: {
                        'background-color': designToken('hover-secondary'),
                        'border-color': designToken('ui-02'),
                    },
                },
                {
                    name: 'focus',
                    attributes: Object.assign({}, focusState),
                },
                {
                    name: 'active',
                    attributes: {
                        'background-color': designToken('pressed-secondary'),
                        'border-color': designToken('ui-02'),
                        'box-shadow': quickProperty('none'),
                    },
                },
            ],
        },
        {
            name: 'primary',
            tag: 'button',
            children: [getIcon(designToken('icon-05'))],
            attributes: {
                'background-color': designToken('interactive-01'),
                'border-color': designToken('interactive-01'),
                '--goto-icon-color': designToken('icon-05'),
            },
            states: [
                {
                    name: 'hover',
                    attributes: {
                        'background-color': designToken('hover-primary'),
                        'border-color': designToken('hover-primary'),
                    },
                },
                {
                    name: 'focus',
                    attributes: Object.assign({}, primaryElementFocus),
                },
                {
                    name: 'active',
                    attributes: {
                        'background-color': designToken('pressed-primary'),
                        'border-color': designToken('pressed-primary'),
                        'box-shadow': quickProperty('none'),
                    },
                },
            ],
        },
        {
            name: 'success',
            tag: 'button',
            children: [getIcon(designToken('icon-05'))],
            attributes: {
                'background-color': designToken('success-01'),
                'border-color': designToken('round-button-border-success'),
                '--goto-icon-color': designToken('icon-05'),
            },
            states: [
                {
                    name: 'hover',
                    attributes: {
                        'background-color': designToken('hover-success'),
                        'border-color': designToken('hover-success'),
                    },
                },
                {
                    name: 'focus',
                    attributes: {
                        'border-color': designToken('success-01'),
                        'box-shadow': designToken('highlight-success'),
                    },
                },
                {
                    name: 'active',
                    attributes: {
                        'background-color': designToken('pressed-success'),
                        'border-color': designToken('pressed-success'),
                        'box-shadow': quickProperty('none'),
                    },
                },
            ],
        },
        {
            name: 'danger',
            tag: 'button',
            children: [getIcon(designToken('icon-05'))],
            attributes: {
                'background-color': designToken('danger-01'),
                'border-color': designToken('round-button-border-danger'),
                '--goto-icon-color': designToken('icon-05'),
            },
            states: [
                {
                    name: 'hover',
                    attributes: {
                        'background-color': designToken('hover-danger'),
                        'border-color': designToken('hover-danger'),
                    },
                },
                {
                    name: 'focus',
                    attributes: {
                        'border-color': designToken('danger-01'),
                        'box-shadow': designToken('highlight-error'),
                    },
                },
                {
                    name: 'active',
                    attributes: {
                        'background-color': designToken('pressed-danger'),
                        'border-color': designToken('pressed-danger'),
                        'box-shadow': quickProperty('none'),
                    },
                },
            ],
        },
        {
            name: 'inactive',
            children: [getIcon(designToken('text-02'))],
            attributes: {
                'background-color': designToken('interactive-02'),
                'border-color': designToken('ui-02'),
                '--goto-icon-color': designToken('icon-04'),
            },
            states: [
                {
                    name: 'hover',
                    attributes: {
                        'background-color': designToken('hover-secondary'),
                        'border-color': designToken('ui-02'),
                    },
                },
                {
                    name: 'focus',
                    attributes: Object.assign({}, focusState),
                },
                {
                    name: 'active',
                    attributes: {
                        'background-color': designToken('pressed-secondary'),
                        'box-shadow': quickProperty('none'),
                        'border-color': designToken('ui-02'),
                    },
                },
            ],
        },
        {
            name: 'inactive-primary',
            attributes: {
                '--goto-icon-color': designToken('icon-01'),
            },
        },
        {
            name: 'disabled',
            tag: 'button',
            children: [getIcon(designToken('disabled-04'))],
            attributes: {
                cursor: quickProperty('default'),
                'background-color': designToken('disabled-02'),
                'border-color': quickProperty('transparent'),
                '--goto-icon-color': designToken('disabled-04'),
            },
        },
        {
            name: 'secondary-disabled',
            tag: 'button',
            children: [getIcon(designToken('disabled-04'))],
            attributes: {
                cursor: quickProperty('default'),
                'background-color': designToken('interactive-02'),
                'border-color': designToken('disabled-04'),
                '--goto-icon-color': designToken('disabled-04'),
            },
        },
    ],
};
